import { render, staticRenderFns } from "./view41.vue?vue&type=template&id=0222467a&scoped=true&"
import script from "./view41.vue?vue&type=script&lang=js&"
export * from "./view41.vue?vue&type=script&lang=js&"
import style0 from "./view41.vue?vue&type=style&index=0&id=0222467a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222467a",
  null
  
)

export default component.exports